"use client";

import { ArrowRight } from "lucide-react";
import Link from "next/link";
import { useLocale, useTranslations } from "next-intl";
import {
  Button,
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
  Container,
  Section,
  VStack,
} from "@/ui";

export function CTASection() {
  const t = useTranslations("HomePage");
  const locale = useLocale();

  return (
    <Section className="section-spacing bg-gradient-to-b from-muted/30 to-background">
      <Container>
        <Card className="border border-border/30 bg-background/50 backdrop-blur-sm overflow-hidden">
          <CardHeader className="text-center pb-4 pt-10">
            <span className="section-label mb-4 block">{t("cta.label")}</span>
            <CardTitle className="heading-display">{t("cta.title")}</CardTitle>
            <CardDescription className="heading-sub mx-auto mt-4">
              {t("cta.description")}
            </CardDescription>
          </CardHeader>
          <CardContent className="pt-2 pb-10">
            <VStack className="items-center gap-4">
              <Button
                size="lg"
                className="btn-lift gap-2 px-8"
                asChild
              >
                <Link href={`/${locale}/products/categories/new`}>
                  {t("cta.button")}
                  <ArrowRight className="h-4 w-4" />
                </Link>
              </Button>
            </VStack>
          </CardContent>
        </Card>
      </Container>
    </Section>
  );
}
